export enum MeasurementUnit{
    Kilogram = "Kilogram",
    Liter = "Liter",
    Pieces = "Pieces"
  }